"use strict";

var curryN = require("../function/curryN");
;
var _path = function _path(paths, obj) {
  if (paths === void 0) {
    paths = [];
  }
  if (obj === void 0) {
    obj = {};
  }
  var val = obj;
  for (var i = 0; i < paths.length; i++) {
    if (val == null) {
      return undefined;
    }
    val = val[paths[i]];
  }
  return val;
};
module.exports = curryN(2, _path);